import React, { Fragment, useState } from 'react'
import { CrudForm, Snackbar, useEntityManager } from 'elentari'
import { riscoRepository } from './RiscoRepository'
import { Field } from 'react-final-form'
import { TextField } from 'final-form-material-ui'
import { CustomMaskedField } from '../../components/CustomDisabledFields'
import { Grid } from '@material-ui/core'
import { getOnlyDigits } from '../../utils/Utils'
import { validateForm } from './validation'

export const RiscoForm = ({ ...props }) => {
  const [mensagem, setMessage] = useState('')

  const entityManager = useEntityManager({ repository: riscoRepository })

  const handleSubmit = async data => {
    const response = await entityManager.onSubmit({
      id: data.id,
      numero:
        typeof data.numero === 'string'
          ? Number(getOnlyDigits(data.numero))
          : data.numero,
      descricao: data.descricao
    })

    if (!response.ok) {
      setMessage(
        response.message ?? 'Ocorreu algum erro ao tentar salvar o registro.'
      )
      return
    }

    return response
  }

  return (
    <Fragment>
      <CrudForm
        {...props}
        {...entityManager}
        validate={validateForm}
        onSubmit={handleSubmit}
        withPaper
      >
        <Grid container spacing={2}>
          <Grid item md={2} xs={12}>
            <Field
              fullWidth
              name="numero"
              label="Número"
              component={CustomMaskedField}
              mask={[/\d/, /\d/]}
            />
          </Grid>
          <Grid item md={10} xs={12}>
            <Field
              fullWidth
              name="descricao"
              label="Descrição"
              component={TextField}
            />
          </Grid>
        </Grid>
      </CrudForm>

      <Snackbar
        autoHideDuration={6000}
        message={mensagem}
        onClose={() => {
          setMessage('')
        }}
      />
    </Fragment>
  )
}
